
import requestHelper from '../../plugins/requestHelper';
import errors from '../../plugins/errors';
export class Survey {
    constructor(surDomEl ) {

        this.survey = surDomEl;
        this.actionUrl = this.survey.getAttribute('data-survey-url');

        this.survey_main = this.survey.querySelector('[data-survey-main]');
        this.survey_yes = this.survey.querySelector('[data-survey-yes]');
        this.survey_no = this.survey.querySelector('[data-survey-no]');
        this.survey_typ = this.survey.querySelector('[data-survey-typ]');
        this.survey_error = this.survey.querySelector('[data-survey-error]');
        this.error_field = this.survey_error.querySelector('[data-error-field]')

        this.btn_yes = this.survey_main.querySelector('[data-btnyes]');
        this.btn_no = this.survey_main.querySelector('[data-btnno]');
        this.form = this.survey_no.querySelector('[data-form]');
        this.form_submit = this.form.querySelector('[data-submit]');
        this.surveyId = this.survey.getAttribute('id');
        this.userId = '';
        this.pageid = this.form.querySelector('[data-page]').value;

        this.dataToSend = {
            recordid: "",
            moduleid: this.surveyId,
            pageid: this.pageid,
            answer: "",
            textinfo: ""
        };

        this.survey.style.backgroundColor = this.survey_main.getAttribute('data-color');

        this.btn_yes.addEventListener('click', () => {

            this.btn_yes.disabled = true;
            this.dataToSend.answer = "1";

            requestHelper
                .request("post", this.actionUrl, JSON.stringify(this.dataToSend) )
                .then(res => {

                    const data = JSON.parse(res);

                    if (data.success){
                        this.survey_main.classList.add('is-hidden');
                        this.userId = data.recordid;
                        this.survey_yes.classList.remove('is-hidden');
                        this.survey.style.backgroundColor = this.survey_yes.getAttribute('data-color');
                    }else{
                        this.showErrorMsg(data.ErrorCode)
                    }
                })
            .catch(
                e => {
                    console.log(e)
                    this.showErrorMsg(e.status);
                }
            );

        });
    
        this.btn_no.addEventListener('click', () => {

            this.btn_no.disabled = true;
            this.dataToSend.answer = "0";

            requestHelper
                .request("post", this.actionUrl, JSON.stringify(this.dataToSend) )
                .then(res => {

                    const data = JSON.parse(res);

                    if (data.success){
                        this.survey_main.classList.add('is-hidden');
                        this.userId = data.recordid;
                        this.survey_no.classList.remove('is-hidden');
                        this.survey.style.backgroundColor = this.survey_no.getAttribute('data-color');
                    }else{
                        this.showErrorMsg(data.ErrorCode)
                    }
                })
                .catch(
                    e => {
                        console.log(e)
                        this.showErrorMsg(e.status);
                    }
                );

        });
    
        this.form_submit.addEventListener('click', () => {

            console.log('asd')

            this.form_submit.disabled = true;

            this.dataToSend.recordid = this.userId;
            this.dataToSend.textinfo = this.form.querySelector('textarea').value;

            requestHelper
                .request("post", this.actionUrl, JSON.stringify(this.dataToSend) )
                .then(res => {

                    const data = JSON.parse(res);

                    if (data.success){
                        this.survey_no.classList.add('is-hidden');
                        this.survey_typ.classList.remove('is-hidden');
                        this.survey.style.backgroundColor = this.survey_typ.getAttribute('data-color');
                    }else{
                        this.showErrorMsg(data.ErrorCode)
                    }
                })
                .catch(
                    e => {
                        console.log(e)
                        this.showErrorMsg(e.status);
                    }
                );
                    
        });
    }
    showErrorMsg(eCode){
        this.survey_main.classList.add('is-hidden');
        this.survey_error.classList.remove('is-hidden');
        this.survey.style.backgroundColor = this.survey_error.getAttribute('data-color');  
        errors.showError(eCode, this.error_field);
    }

}

class SurveyList {
    constructor() {}
    init(){
        this.surveyDomElements = document.querySelectorAll('[data-survey]');
        this.surveyArr = [];
        [].forEach.call(this.surveyDomElements, (el) => {
            this.surveyArr.push(new Survey(el)); 
        }); 
    }

}

const surveys = new SurveyList();
export { surveys }



